<template>
    <div>
        <v-row v-if="assign.company===null && assign.group===null || assign.company!==null && assign.group===null">
            <v-col>
                <select-item name="company" action="/companies/list" v-model="assign.company" item-value="id"
                    item-text="name" :label="trans('companies.item_name')" @change="initAssign('company')" clearable outlined>
                </select-item>
            </v-col>
            <v-col v-if="assign.company != null">
                <select-item name="brand" :action="'/companies/' + assign.company.id + '/brands'" v-model="assign.brand"
                    item-value="id" item-text="name" :label="trans('brands.item_name')"
                    @change="initAssign('brand')" clearable outlined>
                </select-item>
            </v-col>
        </v-row>
        <v-row v-if="assign.company===null && assign.group===null || assign.company===null && assign.group!==null">
            <v-col>
                <select-item name="group" :action="'/groups/list'" v-model="assign.group" item-value="id"
                    item-text="name" :label="trans('groups.item_name')" @change="initAssign('group')" clearable outlined>
                </select-item>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <select-item name="point" :action="pointAction" v-model="assign.point"
                    v-if="assign.group != null || assign.brand != null" item-value="id" item-text="name"
                    :label="trans('points.item_name')" clearable outlined>
                </select-item>
            </v-col>
        </v-row>
    </div>
</template>
<script>

export default {
    name: "assign",
    props: {
        tree: {type: Object, default(){ return {}}},
        errorMessage: {},
    },
    data() {
        return {
            assign: {
                company: null,
                brand: null,
                group: null,
                point: null
            },
            pointAction: '/',
        }
    },
    created() {
        this.assign = this.tree;
    },
    watch: {
        'assign': {
            handler: function (newValue, oldValue) {
                if (newValue.brand !== null) {
                    this.pointAction = '/brands/' + newValue.brand.id + '/points';
                }
                else if (newValue.group !== null) {
                    this.pointAction = '/groups/' + newValue.group.id + '/points';
                }
                else {
                    this.pointAction = '/';
                }
                this.$emit('assign', newValue );
            },
            deep: true,
        },
    },
    methods: {
        initAssign(element) { //inizializza le entità dei livelli inferiori quando si cambia valore
            switch (element) {
                case 'company':
                case 'group':
                    this.assign.company = null;
                    this.assign.brand = null;
                    this.assign.group = null;
                    this.assign.point = null;
                    break;
                case 'brand':
                    this.assign.brand = null;
                    this.assign.group = null;
                    this.assign.point = null;
                    break;
            }
        },
    },
}
</script>
